import {autoinject, BindingEngine, transient, useView} from "aurelia-framework";
import { CustomGridPageBase } from "../../common/custom-grid-page.base";
import { QueriesClientService } from "../../../../services/queries/queries-client.services";
import { I18N } from "aurelia-i18n";
import { SourceType, DataType, QueryFilter } from "../../../../models/queries/queries.models";
import { Router } from "aurelia-router";
import { DialogClientService } from "@rightship-tech/common-ui/services/basic/dialog-client.service";
import { RightShipDialogServiceConstants } from "../../../../constants/basics/rightship-dialog.constants";
import { StepModel } from "../../../../models/basics/basics.models";
import { ConfigService } from "@rightship-tech/common-ui/services/basic/config.service";

@autoinject()
@transient()
@useView('views/pages/modules/pipeline-executions/pipeline-execution.html')
export class PipelineExecution extends CustomGridPageBase {

    private _safetyNetTabs: any[] = [{
        show: true,
        title: () => `Safety Net Results`,
        step: 1,
        onClick: () => {
            this.loadItemSourceForSafetyNetResults();
        }
    },
    {
        show: true,
        title: () => `ETL Process Execution Items`,
        step: 2,
        onClick: () => {
            this.loadItemSourceForDataFiles(false);
        },
        showStatusFilters: true
    }];

    private _survivorshipRulesTabs: any[] = [{
        show: true,
        title: () => `Survivorship Rule Failures`,
        step: 1,
        onClick: () => {
            this.loadItemSourceForSurvivorshipRuleFailures();
        }
    },
    {
        show: true,
        title: () => `ETL Process Execution Items`,
        step: 2,
        onClick: () => {
            this.loadItemSourceForDataFiles(false);
        },
        showStatusFilters: true
    }];

    private _defaultTabs: any[] = [
        {
            show: true,
            title: () => `ETL Process Execution Items`,
            step: 1,
            onClick: () => {
                this.loadItemSourceForDataFiles(true);
            },
            showStatusFilters: true
        }];

    public loadingProcesses: boolean;
    public processes: any[] = [];
    public selectedProcess: any;
    public successfullItems: number;
    public failedItems: number;
    public progressItems: number;
    public isMobileFilterOpen: boolean;
    public selectedStatusFilter: { name: string, id: number, value: boolean }[] = [];
    public mobileSelectedFilter: { name: string, id: number, value: boolean }[] = [];
    public etlProcessExecutiomItemStatuses: { name: string, id: number, value: boolean }[] = [{
        id: 1,
        name: "Successful",
        value: true
    }, {
        id: 2,
        name: "Failed",
        value: false
    }, {
        id: 3,
        name: "In Progress",
        value: null
    }];

    public currentTab: StepModel;
    public tabs: StepModel[] = [];

    public constructor(i18N: I18N, protected bindingEngine: BindingEngine, private configService: ConfigService,
        private queriesClientService: QueriesClientService,
        private dialogClientService: DialogClientService,
        private router: Router) {
        super(i18N, "Items", bindingEngine)
    }

    activate(params: { name: string }) {
        this.loadingProcesses = true;
        this.queriesClientService.getData(`/odata/ETLProcessExecutions?$filter=executionGroup eq '${params.name}'&$orderby=executionStart asc`).then(response => {
            this.processes = response.value;
            this.loadingProcesses = false;
        });
    }

    selectProcess(process: any) {
        this.selectedStatusFilter = [];
        this.selectedProcess = process;
        if (this.selectedProcess.referenceName.indexOf("EMR") == 0) {
            this.tabs = this._survivorshipRulesTabs;
        } else if (this.selectedProcess.referenceName.indexOf("E-SNC") == 0) {
            this.tabs = this._safetyNetTabs;
        } else {
            this.tabs = this._defaultTabs;
        }
        this.currentTab = this.tabs[0];
        setTimeout(() => {
            this.currentTab.onClick(null);
        });
    }

    loadItemSourceForSafetyNetResults() {
        const columns = [];
        columns.push(
            {
                sortOrder: 0,
                columnOrder: 0,
                dataType: DataType.Default,
                isSortable: true,
                name: 'configurationName',
                title: 'Configuration Name'
            },
            {
                sortOrder: 0,
                columnOrder: 0,
                dataType: DataType.Default,
                isSortable: true,
                name: 'validatioName',
                title: 'Validatio Name'
            },
            {
                sortOrder: 0,
                columnOrder: 0,
                dataType: DataType.Default,
                isSortable: true,
                name: 'safetyNetValidationType',
                title: 'Validatio Level'
            },
            {
                sortOrder: 0,
                columnOrder: 0,
                dataType: DataType.Default,
                isSortable: true,
                name: 'validationMessage',
                title: 'Validation Message'
            },
            {
                sortOrder: 0,
                columnOrder: 0,
                dataType: DataType.Boolean,
                isSortable: true,
                name: 'isValidationSuccessful',
                title: 'Is Validation Successful'
            });

        columns.forEach((column, index) => {
            column.columnOrder = index;
            column.sortOrder = index;
        });

        this.columns = columns;
        this.itemSource = {
            sourceType: SourceType.ODataUrl,
            source: "odata/SafetyNetResults?$filter=etlProcessExecutionId eq " + this.selectedProcess.etlProcessExecutionId,
            columns: this.columns,
            initialFilters: []
        };
    }

    loadItemSourceForSurvivorshipRuleFailures() {
        const columns = [];
        columns.push(
            {
                sortOrder: 0,
                columnOrder: 0,
                dataType: DataType.Default,
                isSortable: true,
                name: 'dataType',
                title: 'Data Type'
            },
            {
                sortOrder: 0,
                columnOrder: 0,
                dataType: DataType.Default,
                isSortable: true,
                name: 'columnName',
                title: 'Column Name'
            },
            {
                sortOrder: 0,
                columnOrder: 0,
                dataType: DataType.Default,
                isSortable: true,
                name: 'errorText',
                title: 'Error Text'
            },
            {
                sortOrder: 0,
                columnOrder: 0,
                dataType: DataType.Number,
                isSortable: true,
                name: 'affectedRecordsCount',
                title: 'Affected Records Count'
            });

        columns.forEach((column, index) => {
            column.columnOrder = index;
            column.sortOrder = index;
        });

        this.columns = columns;
        this.itemSource = {
            sourceType: SourceType.ODataUrl,
            source: "odata/SurvivorshipRuleFailures/GetSurvivorshipRuleFailures(etlProcessExecutionId =" + this.selectedProcess.etlProcessExecutionId + ")",
            columns: this.columns,
            initialFilters: []
        };
    }

    loadItemSourceForDataFiles(hasFiles: boolean) {
        const columns = [];
        if (hasFiles) {
            columns.push({
                columnOrder: 0,
                sortOrder: 0,
                dataType: DataType.Number,
                isSortable: true,
                name: 'etlProcessExecutionItemId',
                title: 'ID'
            },
                {
                    columnOrder: 0,
                    sortOrder: 0,
                    dataType: DataType.CustomTemplate,
                    isSortable: true,
                    instancePerRow: true,
                    name: 'fileName',
                    title: 'File Name',
                    value: '<a class="link" href.bind="mdmBlob + item.fileLocation" target="_blank" download>${item.fileName}</a>',
                    parameter: {
                        item: null,
                        mdmBlob: this.configService.config.urls.mdmBaseStorageUrl
                    }
                },
                {
                    columnOrder: 0,
                    sortOrder: 0,
                    dataType: DataType.Default,
                    isSortable: true,
                    name: 'isSuccessful',
                    title: 'Outcome',
                    valueConverter: value => value == true ? 'Successful' : (value == false ? 'Failed' : 'In Progress')
                },
                {
                    columnOrder: 0,
                    sortOrder: 0,
                    dataType: DataType.Default,
                    isSortable: true,
                    instancePerRow: true,
                    name: 'errorLogs',
                    title: 'Logs'
                });
        } else {
            columns.push({
                columnOrder: 0,
                sortOrder: 0,
                dataType: DataType.Number,
                isSortable: true,
                name: 'etlProcessExecutionItemId',
                title: 'ID'
            },
                {
                    columnOrder: 0,
                    sortOrder: 0,
                    dataType: DataType.Default,
                    isSortable: true,
                    name: 'isSuccessful',
                    title: 'Outcome',
                    valueConverter: value => value == true ? 'Successful' : (value == false ? 'Failed' : 'In Progress')
                },
                {
                    columnOrder: 0,
                    sortOrder: 0,
                    dataType: DataType.Default,
                    isSortable: true,
                    instancePerRow: true,
                    name: 'errorLogs',
                    title: 'Logs'
                });
        }

        columns.forEach((column, index) => {
            column.columnOrder = index;
            column.sortOrder = index;
        });

        this.columns = columns;
        const filters = [
            QueryFilter.getQuery("etlProcessExecutionId", this.selectedProcess["etlProcessExecutionId"], "eq", DataType.Number)
        ];

        if (this.selectedStatusFilter && this.selectedStatusFilter.length > 0) {
            this.selectedStatusFilter.forEach((x, index) => {
                const filter = QueryFilter.getQuery("isSuccessful", x.value, "eq", DataType.Boolean, index == 0, false, "statusGroup", true);
                filter.skipOnNullOrEmpty = false;
                filters.push(filter);
            });
        }

        this.itemSource = {
            sourceType: SourceType.ODataUrl,
            source: "odata/ETLProcessExecutionItems",
            columns: this.columns,
            initialFilters: filters
        };

        this.queriesClientService.getData(`/odata/ETLProcessExecutionItems?$filter=isSuccessful eq true and etlProcessExecutionId eq ${this.selectedProcess["etlProcessExecutionId"]}&&$count=true&$top=0`).then(response => {
            this.successfullItems = response["@odata.count"];
        });

        this.queriesClientService.getData(`/odata/ETLProcessExecutionItems?$filter=isSuccessful eq false and etlProcessExecutionId eq ${this.selectedProcess["etlProcessExecutionId"]}&&$count=true&$top=0`).then(response => {
            this.failedItems = response["@odata.count"];
        });

        this.queriesClientService.getData(`/odata/ETLProcessExecutionItems?$filter=isSuccessful eq null and etlProcessExecutionId eq ${this.selectedProcess["etlProcessExecutionId"]}&&$count=true&$top=0`).then(response => {
            this.progressItems = response["@odata.count"];
        });
    }

    showErrorLogs(process: any) {
        this.dialogClientService.show(RightShipDialogServiceConstants.URLs.PipelineExecutionErrorLogsDialog, {
            process: process
        }, true, true, false, 'right');
    }

    openWarningDetails(process: any) {
        this.dialogClientService.show(RightShipDialogServiceConstants.URLs.PipelineExecutionWarningDialog, {
            process: process
        }, true, true, false, 'right');
    }

    back() {
        if (this.selectedProcess) {
            this.selectedProcess = null;
        } else {
            this.router.navigateBack();
        }
    }

    filterClick(status: { name: string, id: number, value: boolean }) {
        const index = this.selectedStatusFilter.indexOf(status);
        const isSelected = index != -1;
        if (!isSelected) {
            this.selectedStatusFilter.push(status);
        } else {
            this.selectedStatusFilter.splice(index, 1);
        }

        this.currentTab.onClick(null);
    }

    public mobileFilterClick(status: { name: string, id: number, value: boolean }) {
        const index = this.mobileSelectedFilter.indexOf(status);
        const isSelected = index != -1;

        if (!isSelected) {
            this.mobileSelectedFilter.push(status);
        } else {
            this.mobileSelectedFilter.splice(index, 1);
        }
    }

    clearAllFilters() {
        this.selectedStatusFilter = [];
        this.mobileSelectedFilter = [];
        this.currentTab.onClick(null);
    }

    toggleMobileFilterDialog() {
        this.isMobileFilterOpen = !this.isMobileFilterOpen;
    }

    public mobileFilterApply(toggleDialog: boolean = true) {
        if (toggleDialog)
            this.toggleMobileFilterDialog();

        this.selectedStatusFilter = [];

        if (this.mobileSelectedFilter && this.mobileSelectedFilter.length > 0) {
            for (const item of this.mobileSelectedFilter) {
                this.filterClick(item);
            }
        } else {
            this.currentTab.onClick(null);
        }
    }

    getCount(status: { name: string, id: number, value: boolean }) {
        if (status.id == 1) {
            return this.successfullItems;
        }
        else if (status.id == 2) {
            return this.failedItems;
        }
        else if (status.id == 3) {
            return this.progressItems;
        }
        return 0;
    }
}